import { render, staticRenderFns } from "./ArrangedArtistTemplate.vue?vue&type=template&id=36560c7c&scoped=true&"
import script from "./ArrangedArtistTemplate.vue?vue&type=script&lang=js&"
export * from "./ArrangedArtistTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ArrangedArtistTemplate.vue?vue&type=style&index=0&id=36560c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36560c7c",
  null
  
)

export default component.exports